var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "passenger-info" }, [
    _c("div", { staticClass: "name-row" }, [
      _c("div", { staticClass: "field" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          staticClass: "field-input",
          class: { "has-error": _vm.errors.first_name },
          attrs: { type: "text", placeholder: "Jane" },
          domProps: { value: _vm.value.first_name },
          on: {
            input: function($event) {
              return _vm.update("first_name", $event.target.value)
            },
            blur: function($event) {
              return _vm.touch("first_name")
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.first_name
          ? _c("p", { staticClass: "field-error" }, [
              _vm._v(_vm._s(_vm.errors.first_name))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("input", {
          staticClass: "field-input",
          class: { "has-error": _vm.errors.last_name },
          attrs: { type: "text", placeholder: "Doe" },
          domProps: { value: _vm.value.last_name },
          on: {
            input: function($event) {
              return _vm.update("last_name", $event.target.value)
            },
            blur: function($event) {
              return _vm.touch("last_name")
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.last_name
          ? _c("p", { staticClass: "field-error" }, [
              _vm._v(_vm._s(_vm.errors.last_name))
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    !_vm.hideEmail
      ? _c("div", { staticClass: "field" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("input", {
            staticClass: "field-input",
            class: { "has-error": _vm.errors.email },
            attrs: { type: "email", placeholder: "jane@example.com" },
            domProps: { value: _vm.value.email },
            on: {
              input: function($event) {
                return _vm.update("email", $event.target.value)
              },
              blur: function($event) {
                return _vm.touch("email")
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.email
            ? _c("p", { staticClass: "field-error" }, [
                _vm._v(_vm._s(_vm.errors.email))
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "field-label" }, [
        _vm._v(_vm._s(_vm.$t("mobile")) + " "),
        _c("span", { staticClass: "req" }, [_vm._v("*")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "phone-row" },
        [
          _c("PhonePrefixSelect", {
            staticClass: "phone-prefix",
            attrs: { value: _vm.value.mobile_prefix || "+61" },
            on: {
              change: function($event) {
                return _vm.update("mobile_prefix", $event)
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "field-input phone-number",
            class: { "has-error": _vm.errors.mobile_number },
            attrs: { type: "tel", placeholder: "412 345 678" },
            domProps: { value: _vm.value.mobile_number },
            on: {
              input: function($event) {
                return _vm.update("mobile_number", $event.target.value)
              },
              blur: function($event) {
                return _vm.touch("mobile_number")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.errors.mobile_number
        ? _c("p", { staticClass: "field-error" }, [
            _vm._v(_vm._s(_vm.errors.mobile_number))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name-row identity-row" }, [
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "field-label" }, [
          _vm._v(_vm._s(_vm.$t("passport")))
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "field-input",
          class: { "has-error": _vm.errors.passport || _vm.errors.identity },
          attrs: { type: "text", placeholder: _vm.$t("passport") },
          domProps: { value: _vm.value.passport },
          on: {
            input: function($event) {
              return _vm.onPassportInput($event.target.value)
            },
            blur: function($event) {
              return _vm.touch("passport")
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.passport
          ? _c("p", { staticClass: "field-error" }, [
              _vm._v(_vm._s(_vm.errors.passport))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "field-label" }, [
          _vm._v(_vm._s(_vm.$t("licence")))
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "field-input",
          class: { "has-error": _vm.errors.licence || _vm.errors.identity },
          attrs: { type: "text", placeholder: _vm.$t("licence") },
          domProps: { value: _vm.value.licence },
          on: {
            input: function($event) {
              return _vm.onLicenceInput($event.target.value)
            },
            blur: function($event) {
              return _vm.touch("licence")
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.licence
          ? _c("p", { staticClass: "field-error" }, [
              _vm._v(_vm._s(_vm.errors.licence))
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.requireIdentity
      ? _c("p", { staticClass: "identity-hint" }, [
          _vm._v(_vm._s(_vm.$t("eitherPassportOrLicence")))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.errors.identity
      ? _c("p", { staticClass: "field-error identity-error" }, [
          _vm._v(_vm._s(_vm.errors.identity))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "name-row" }, [
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "field-label" }, [_vm._v("Flight Number")]),
        _vm._v(" "),
        _c("input", {
          staticClass: "field-input",
          attrs: { type: "text", placeholder: "QF123" },
          domProps: { value: _vm.value.flight_no },
          on: {
            input: function($event) {
              return _vm.update("flight_no", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "field-label" }, [_vm._v("Travel Date")]),
        _vm._v(" "),
        _c("input", {
          staticClass: "field-input",
          attrs: { type: "date" },
          domProps: { value: _vm.value.travel_date },
          on: {
            input: function($event) {
              return _vm.update("travel_date", $event.target.value)
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("Passport First Name "),
      _c("span", { staticClass: "req" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("Last Name "),
      _c("span", { staticClass: "req" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("Email "),
      _c("span", { staticClass: "req" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05f43f30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f43f30","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PassengerInfo.vue
// module id = 421
// module chunks = 0